import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Swiper, SwiperProps } from 'swiper/react';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { Swiper as SwiperType } from 'swiper/types';
import s from './styles.module.scss';

export interface ISlideInfo extends SwiperType {
  activeIndex: number;
}
export interface ISliderClass extends ISlideInfo {
  slideNext(): void;
  slidePrev(): void;
  slideTo(slideNumber: number): void;
}

export interface IAppCaruselProps extends SwiperProps {
  className?: string;
  centered?: boolean;
}

export interface IAppCarouselRef {
  nextSlide: () => void;
  prevSlide: () => void;
  toStart: () => void;
  slideTo(slideNumber: number): void;
}

const AppCarusel = forwardRef<IAppCarouselRef, IAppCaruselProps>(
  (props, ref) => {
    const {
      children,
      className = '',
      initialSlide = 0,
      allowTouchMove = true,
      preventClicks = true,
      centered = false,
      preventClicksPropagation = true,
      simulateTouch = true,
      slidesPerView = 'auto',
      ...rest
    } = props;
    useImperativeHandle(ref, () => ({
      nextSlide,
      prevSlide,
      toStart,
      slideTo,
    }));

    const router = useRouter();
    const { locale } = router;

    const [swiperInstance, setSwiperInstance] = useState<ISliderClass | null>(
      null
    );

    const slideTo = (index: number) => {
      if (swiperInstance) swiperInstance.slideTo(index);
    };
    const toStart = () => {
      if (swiperInstance) swiperInstance.slideTo(0);
    };
    const nextSlide = () => {
      if (swiperInstance) swiperInstance.slideNext();
    };
    const prevSlide = () => {
      if (swiperInstance) swiperInstance.slidePrev();
    };
    const swiperClassNames = classNames(s['swiper'], s[`${locale}`], className);

    return (
      <Swiper
        simulateTouch={simulateTouch}
        allowTouchMove={allowTouchMove}
        preventClicks={preventClicks}
        preventClicksPropagation={preventClicksPropagation}
        className={swiperClassNames}
        slidesPerView={slidesPerView}
        initialSlide={initialSlide}
        centeredSlides={centered}
        onInit={(swiper) => {
          setSwiperInstance(swiper);
        }}
        {...rest}
      >
        {children}
      </Swiper>
    );
  }
);

AppCarusel.displayName = 'AppCarusel';

export default AppCarusel;
